import FormikInput from 'components/formikFields/input'
import { Field, FieldProps } from 'formik'
import DatePicker from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import FormikSwitch from 'pages/promissory/promissory-publish/formikSwitchProps'
import {
    handleFormattedChange,
    handleIbanChange,
} from 'pages/promissory/promissory-publish/handlers/Handlers'
import { processNumericInput } from '../utilities'
import React from 'react'

interface FormStep1Props {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
}

export const FormStep1: React.FC<FormStep1Props> = ({ setFieldValue }) => (
    <div>
        <div className="mb-4">
            <FormikInput
                id="issuerName"
                name="issuerName"
                label=" نام صادر کننده سفته"
                placeholder=""
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="شماره شبا"
                type="text"
                id="issuerIban"
                placeholder="فقط ارقام را بدون IR وارد کنید"
                name="issuerIban"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    handleIbanChange(e.target.value, setFieldValue)
                }}
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="کد ملی صادر کننده سفته"
                type="text"
                id="issuerIdCode"
                name="issuerIdCode"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    processNumericInput(
                        e.target.value,
                        setFieldValue,
                        10,
                        'issuerIdCode'
                    )
                }}
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="کد پستی"
                type="text"
                id="issuerPostalCode"
                name="issuerPostalCode"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    processNumericInput(
                        e.target.value,
                        setFieldValue,
                        10,
                        'issuerPostalCode'
                    )
                }}
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="آدرس صادر کننده سفته"
                as="textarea"
                id="issuerAddress"
                name="issuerAddress"
                rows={2}
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="موبایل صادر کننده سفته"
                type="text"
                id="issuerMobile"
                name="issuerMobile"
                placeholder="برای مثال ۰۹۱۲۱۲۳۴۵۶۷۸"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    processNumericInput(
                        e.target.value,
                        setFieldValue,
                        11,
                        'issuerMobile'
                    )
                }}
            />
        </div>
    </div>
)

export const FormStep2 = ({ setFieldValue }) => (
    <div>
        <div className="mb-4">
            <FormikInput
                label="نام دریافت کننده سفته"
                type="text"
                id="receiverName"
                name="receiverName"
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="کد ملی دریافت کننده سفته"
                type="text"
                id="receiverIdCode"
                name="receiverIdCode"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    processNumericInput(
                        e.target.value,
                        setFieldValue,
                        10,
                        'receiverIdCode'
                    )
                }}
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="شماره موبایل دریافت کننده سفته"
                type="text"
                id="receiverMobile"
                name="receiverMobile"
                placeholder="برای مثال ۰۹۱۲۱۲۳۴۵۶۷۸"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    processNumericInput(
                        e.target.value,
                        setFieldValue,
                        11,
                        'receiverMobile'
                    )
                }}
            />
        </div>
        <FormikSwitch
            name="receiverIdType"
            label="نوع دریافت کننده سفته"
            checkedValue="2"
            uncheckedValue="1"
            checkedLabel="حقوقی"
            uncheckedLabel="حقیقی"
        />
    </div>
)

export const FormStep3 = ({
    handleDateChange,
    setFieldValue,
    values,
    errors,
    touched,
}) => (
    <div>
        <div className="mb-4">
            <FormikInput
                label="محل پرداخت"
                type="text"
                id="paymentPlace"
                name="paymentPlace"
            />
        </div>
        <div className="mb-4">
            <FormikInput
                label="مقدار سفته"
                type="text"
                id="amount"
                name="amount"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const formattedValue = handleFormattedChange(
                        e.target.value,
                        setFieldValue,
                        'amount'
                    )
                    setFieldValue('amount', formattedValue)
                }}
            />
        </div>
        <div className="mb-4 flex-col items-start justify-start">
            <label
                htmlFor="duDate"
                className=" text-gray-1 text-sm font-bold mb-2"
            >
                تاریخ پایان سفته
            </label>
            <Field name="duDate">
                {({ form }: FieldProps) => (
                    <>
                        <DatePicker
                            id="duDate"
                            calendar={persian}
                            locale={persian_fa}
                            value={values.duDate}
                            onChange={(date) =>
                                handleDateChange(date, form.setFieldValue)
                            }
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-1 leading-tight focus:outline-none focus:shadow-outline"
                        />
                        {typeof errors.duDate === 'string' &&
                        touched.duDate &&
                        errors.duDate ? (
                            <div className="text-red-1 text-xs italic">
                                {errors.duDate}
                            </div>
                        ) : null}
                    </>
                )}
            </Field>
        </div>
        <div className="mb-4">
            <FormikInput
                label="توضیحات"
                as="textarea"
                id="description"
                name="description"
                rows={2}
            />
        </div>
        <FormikSwitch
            name="transferable"
            label="قابل حواله کرد"
            checkedValue={true}
            uncheckedValue={false}
            checkedLabel="بله"
            uncheckedLabel="خیر"
        />
    </div>
)
